export function dateToString(date) {
    return date.getFullYear().toString() + "-" + (date.getMonth() + 1).toString().padStart(2, 0) + "-" + date.getDate().toString().padStart(2, 0)
}

export function isValidDate(date) {
    if (typeof (date) === 'string')
        return (dateToString(new Date(date)) === date)
}

export function dateToAge(date) {

    if (!isValidDate(date)) return
    let birthday = new Date(date);
    //calculate difference from current date in time    
    let ms_def = new Date().setHours(0, -(new Date().getTimezoneOffset()), 0) - birthday.getTime();
    //convert the calculated difference in date format  
    let date_delta = new Date(ms_def);

    //extract year from date      
    let years = date_delta.getFullYear() - 1970;
    let months = date_delta.getMonth();
    let days = date_delta.getDate() - 1
    // console.log(`date: ${date} , age: ${years} , months: ${months} , days: ${days}`)
    if (years < 0)
        return 0
    let age = Math.abs(years);
    
    if (age === 0 && (months < 6 || (months === 6 && days === 0)))
        return 0.5

    if (months > 0 || days > 0) age++
    return age
}

export function dateToAgeMonths(date) {

    if (!isValidDate(date)) return null
    let birthday = new Date(date);
    //calculate difference from current date in time
    let ms_def = new Date().setHours(0, -(new Date().getTimezoneOffset()), 0) - birthday.getTime();
    //convert the calculated difference in date format
    let date_delta = new Date(ms_def);

    //extract year from date
    let years = date_delta.getFullYear() - 1970;
    let months = date_delta.getMonth();

    if (years < 0)
        return 0
    // completed (floored) months: 1 day before the next month still counts as the current one,
    // so a child fits a plan until they actually reach its maxAgeMonths
    return Math.max(0, years * 12 + months)
}

export function ageToMonths(age, preBorn = false) {
    if (preBorn || age === null || age === undefined || age === '') return (preBorn) ? 0 : null
    if (Number(age) === 0) return 0
    // Selector value N means "up to N years": sit one month below the bracket top so only the
    // bracket ending at N matches (the next bracket starts at N*12). 0.5*12 - 1 = 5 falls through.
    return Number(age) * 12 - 1
}

export function getBirthdayMonthsOffest(date,age) {
    if (!isValidDate(date)) return 0
    let birthday = new Date(date);
    //calculate difference from current date in time    
    let ms_def = new Date().setHours(0, -(new Date().getTimezoneOffset()), 0) - birthday.getTime();
    //convert the calculated difference in date format  
    let date_delta = new Date(ms_def);

    //extract year from date      
    let years = date_delta.getFullYear() - 1970;
    let months = date_delta.getMonth();
    let days = date_delta.getDate() - 1
    
    let offset = Math.abs(age -years) * 12 - months;
    // if (days > 0)
    //     offset--;
    // console.log(`date: ${date} , age: ${age} ,years: ${years}, months: ${months} , days: ${days} , offset: ${offset}`)
    return offset

}

export function getDateAge(date, age) {
    if (age === 0.5) {
        let newDate = Date.now() - 15780000000;
        return dateToString(newDate)
    }
    if (!date || dateToAge(date) < 1) {
        let newDate = new Date();
        newDate.setYear(newDate.getFullYear() - Number(age))
        return dateToString(newDate)

    }

    let oldAge = dateToAge(date)
    if (oldAge >= 1) {
        let newDate = new Date(date);
        newDate.setYear(newDate.getFullYear() - Number(age) + oldAge)
        return dateToString(newDate)
    }

}